import { render, staticRenderFns } from "./SelectClientes.vue?vue&type=template&id=12c17d35&scoped=true"
import script from "./SelectClientes.vue?vue&type=script&lang=js"
export * from "./SelectClientes.vue?vue&type=script&lang=js"
import style0 from "./SelectClientes.vue?vue&type=style&index=0&id=12c17d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c17d35",
  null
  
)

export default component.exports